// extracted by mini-css-extract-plugin
export default {"test-h1":"archive_test-h1__+icSP"};